import http from "./client";


async function qr(): Promise<{status: 'ok', code: 'string', token: 'string'}> {
  const response = await http.get('/account/qrcode');
  return response.data;
}

const account = {
  qr
};

export default account;